// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Banner Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.banner-modal {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e5e5;
    background-color: #f8f9fa;
}

.modal-header h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.modal-close {
    background: none;
    border: none;
    font-size: 24px;
    color: #666;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
}

.modal-close:hover {
    background-color: #e9ecef;
}

.modal-body {
    padding: 24px;
    max-height: calc(90vh - 140px);
    overflow-y: auto;
}

.form-row {
    margin-bottom: 20px;
}

.form-row label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
    font-size: 14px;
}

.form-row input,
.form-row select {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.2s;
}

.form-row input:focus,
.form-row select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-row-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 20px;
}

.file-input-group {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.btn-file-select {
    background-color: #000000;
    color: white;
    border: none;
    padding: 10px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s;
}

.btn-file-select:hover:not(:disabled) {
    background-color: #333333;
}

.btn-file-select:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

.file-name {
    color: #666;
    font-size: 14px;
    flex: 1 1;
    min-width: 150px;
}

.btn-remove-image {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.2s;
}

.btn-remove-image:hover {
    background-color: #c82333;
}

.upload-status {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
}

.success-text {
    color: #28a745;
    font-weight: 500;
    font-size: 14px;
}

.s3-link {
    color: #007bff;
    text-decoration: none;
    font-size: 12px;
    padding: 4px 8px;
    border: 1px solid #007bff;
    border-radius: 3px;
    transition: all 0.2s;
}

.s3-link:hover {
    background-color: #007bff;
    color: white;
}

.image-preview {
    margin-top: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    max-width: 300px;
}

.image-preview img {
    width: 100%;
    height: auto;
    display: block;
}

.checkbox-label {
    display: flex !important;
    align-items: center;
    cursor: pointer;
    margin-bottom: 0 !important;
}

.checkbox-label input {
    width: auto !important;
    margin-right: 8px;
    margin-bottom: 0;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 20px;
    margin-top: 20px;
    border-top: 1px solid #e5e5e5;
}

.btn-cancel,
.btn-submit {
    padding: 10px 20px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-cancel {
    background-color: #6c757d;
    color: white;
    border: none;
}

.btn-cancel:hover {
    background-color: #5a6268;
}

.btn-submit {
    background-color: #222;
    color: white;
    border: none;
}

.btn-submit:hover:not(:disabled) {
    background-color: #333;
}

.btn-submit:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .banner-modal {
        width: 95%;
        max-height: 95vh;
    }
    
    .modal-header,
    .modal-body {
        padding: 16px;
    }
    
    .form-row-group {
        grid-template-columns: 1fr;
        gap: 12px;
    }
    
    .file-input-group {
        flex-direction: column;
        align-items: stretch;
    }
    
    .file-name {
        min-width: auto;
    }
    
    .modal-footer {
        flex-direction: column;
    }
    
    .btn-cancel,
    .btn-submit {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/BannerModal.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;AACJ","sourcesContent":["/* Banner Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.banner-modal {\n    background: white;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 600px;\n    max-height: 90vh;\n    overflow: hidden;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    border-bottom: 1px solid #e5e5e5;\n    background-color: #f8f9fa;\n}\n\n.modal-header h2 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.modal-close {\n    background: none;\n    border: none;\n    font-size: 24px;\n    color: #666;\n    cursor: pointer;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: background-color 0.2s;\n}\n\n.modal-close:hover {\n    background-color: #e9ecef;\n}\n\n.modal-body {\n    padding: 24px;\n    max-height: calc(90vh - 140px);\n    overflow-y: auto;\n}\n\n.form-row {\n    margin-bottom: 20px;\n}\n\n.form-row label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 500;\n    color: #333;\n    font-size: 14px;\n}\n\n.form-row input,\n.form-row select {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    transition: border-color 0.2s;\n}\n\n.form-row input:focus,\n.form-row select:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.form-row-group {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.file-input-group {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.btn-file-select {\n    background-color: #000000;\n    color: white;\n    border: none;\n    padding: 10px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.2s;\n}\n\n.btn-file-select:hover:not(:disabled) {\n    background-color: #333333;\n}\n\n.btn-file-select:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n}\n\n.file-name {\n    color: #666;\n    font-size: 14px;\n    flex: 1;\n    min-width: 150px;\n}\n\n.btn-remove-image {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: background-color 0.2s;\n}\n\n.btn-remove-image:hover {\n    background-color: #c82333;\n}\n\n.upload-status {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-top: 8px;\n}\n\n.success-text {\n    color: #28a745;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.s3-link {\n    color: #007bff;\n    text-decoration: none;\n    font-size: 12px;\n    padding: 4px 8px;\n    border: 1px solid #007bff;\n    border-radius: 3px;\n    transition: all 0.2s;\n}\n\n.s3-link:hover {\n    background-color: #007bff;\n    color: white;\n}\n\n.image-preview {\n    margin-top: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    overflow: hidden;\n    max-width: 300px;\n}\n\n.image-preview img {\n    width: 100%;\n    height: auto;\n    display: block;\n}\n\n.checkbox-label {\n    display: flex !important;\n    align-items: center;\n    cursor: pointer;\n    margin-bottom: 0 !important;\n}\n\n.checkbox-label input {\n    width: auto !important;\n    margin-right: 8px;\n    margin-bottom: 0;\n}\n\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding-top: 20px;\n    margin-top: 20px;\n    border-top: 1px solid #e5e5e5;\n}\n\n.btn-cancel,\n.btn-submit {\n    padding: 10px 20px;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-cancel {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n}\n\n.btn-cancel:hover {\n    background-color: #5a6268;\n}\n\n.btn-submit {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.btn-submit:hover:not(:disabled) {\n    background-color: #333;\n}\n\n.btn-submit:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n    .banner-modal {\n        width: 95%;\n        max-height: 95vh;\n    }\n    \n    .modal-header,\n    .modal-body {\n        padding: 16px;\n    }\n    \n    .form-row-group {\n        grid-template-columns: 1fr;\n        gap: 12px;\n    }\n    \n    .file-input-group {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    \n    .file-name {\n        min-width: auto;\n    }\n    \n    .modal-footer {\n        flex-direction: column;\n    }\n    \n    .btn-cancel,\n    .btn-submit {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
